/* Bloomelle V3 theme JS */
(function(){
  // mobile menu
  var t=document.querySelector('.mobile-toggle'),m=document.querySelector('.mobile-menu');
  if(t&&m)t.addEventListener('click',function(){m.classList.toggle('open')});

  // announcement rotation: desktop only (static on mobile per blueprint)
  var ann=document.querySelector('[data-announcements]');
  if(ann&&window.matchMedia('(min-width:768px)').matches){
    try{
      var msgs=JSON.parse(ann.dataset.announcements),i=0;
      if(msgs.length>1)setInterval(function(){i=(i+1)%msgs.length;ann.innerHTML=msgs[i]},4000);
    }catch(e){}
  }

  // PDP: plan selector (radios drive price, both add buttons, sticky bar)
  var radios=document.querySelectorAll('input[name="plan-option"]');
  function syncPlan(){
    var sel=document.querySelector('input[name="plan-option"]:checked');
    if(!sel)return;
    document.querySelectorAll('.plan').forEach(function(p){p.classList.toggle('selected',p.contains(sel))});
    document.querySelectorAll('[data-plan-price]').forEach(function(el){el.textContent=sel.dataset.priceLabel});
    document.querySelectorAll('[data-plan-name]').forEach(function(el){el.textContent=sel.dataset.label});
    document.querySelectorAll('input[name="id"]').forEach(function(el){el.value=sel.value});
    // SEAL: if the option carries a selling plan, mirror it into the cart form
    document.querySelectorAll('input[name="selling_plan"]').forEach(function(el){
      el.value=sel.dataset.sellingPlan||'';el.disabled=!sel.dataset.sellingPlan;
    });
  }
  if(radios.length){
    radios.forEach(function(r){r.addEventListener('change',syncPlan)});
    document.querySelectorAll('.plan').forEach(function(p){
      p.addEventListener('click',function(){
        var r=p.querySelector('input[name="plan-option"]');
        if(r&&!r.checked){r.checked=true;syncPlan()}
      });
    });
    syncPlan();
  }

  // gallery
  window.bloomelleSwap=function(btn,src,contain){
    var m=document.getElementById('mainImg');if(!m)return;
    m.src=src;m.style.objectFit=contain?'contain':'cover';
    document.querySelectorAll('.thumbs button,.gallery-grid button').forEach(function(b){b.classList.remove('active')});
    btn.classList.add('active');
  };

  // sticky buy bar
  var sticky=document.getElementById('stickyBuy');
  if(sticky){
    var threshold=+(sticky.dataset.threshold||300);
    window.addEventListener('scroll',function(){sticky.classList.toggle('show',window.scrollY>threshold)});
  }

  // ajax add-to-cart with toast
  document.querySelectorAll('form[data-ajax-cart]').forEach(function(form){
    form.addEventListener('submit',function(e){
      e.preventDefault();
      var btn=form.querySelector('[type=submit]');if(btn)btn.disabled=true;
      fetch('/cart/add.js',{method:'POST',body:new FormData(form)})
        .then(function(r){if(!r.ok)throw new Error();return r.json()})
        .then(function(){toast('Added to your bag');document.dispatchEvent(new CustomEvent('cart:added'))})
        .catch(function(){toast('Sorry, something went wrong. Please try again.')})
        .finally(function(){if(btn)btn.disabled=false});
    });
  });
  function toast(msg){
    var t=document.getElementById('toast');
    if(!t){t=document.createElement('div');t.className='toast';t.id='toast';document.body.appendChild(t)}
    t.textContent=msg;t.classList.add('show');
    clearTimeout(t._h);t._h=setTimeout(function(){t.classList.remove('show')},2600);
  }
})();
